// DESIGN.md rev 2 §2.1 — the eight-rung stage ladder and the condition vocabulary.
// Stage is ordinal (a ladder, never a rainbow); condition is one of four semantic tones.
export const STAGES = ['Writing', 'Scripted', 'Filming', 'Filmed', 'Editing', 'Qual', 'Approved', 'Posted'];

export const CONDITIONS = {
  'In progress':    { tone: 'info',   icon: 'progress' },
  'Needs review':   { tone: 'warn',   icon: 'review' },
  'Ready':          { tone: 'ok',     icon: 'ready' },
  'Needs revision': { tone: 'warn',   icon: 'revision' },
  'Not ready':      { tone: 'warn',   icon: 'notready' },
  'Incomplete':     { tone: 'danger', icon: 'incomplete' },
};

// Stage of a script from its qual state and its production card's status (§2.1 "Writing" rule).
export function stageOf({ qualStatus, cardStatus }) {
  if (cardStatus && STAGES.includes(cardStatus)) return cardStatus;
  if (cardStatus === 'Incomplete') return 'Filming';
  if (qualStatus === 'Posted') return 'Posted';
  if (qualStatus === 'Approved') return 'Scripted';
  return 'Writing';
}

// Condition of a script (null when nothing needs attention). Backburner is a row treatment, not a condition.
export function conditionOf({ qualStatus, talStatus, cardStatus }) {
  if (cardStatus === 'Incomplete') return 'Incomplete';
  if (qualStatus === 'Needs Revision') return 'Needs revision';
  if (qualStatus === 'Needs Review') return 'Needs review';
  if (qualStatus === 'I/P') return 'In progress';
  if (qualStatus === 'Approved' && !cardStatus) return talStatus === 'not_ready' ? 'Not ready' : 'Ready';
  return null;
}
